/**
 * Créer ici une variable par langue
 */

export const fr_00707 = {
  'P/N': 'NNO',
  'The P/N field is required': 'Le champ NNO est requis',
  'The P/N field allows only letters, numbers, hyphen, underscore and backslash.': 'Le champ NNO autorise uniquement les lettres, chiffres, traits d\'union, tirets _ et antislash \\',
  "At the time of this service, the P/N of the tooling was": 'Au moment du service, le NNO de l\'outillage était',
  "Specific PNs": "NNOs Spécifique",
  "PNs spécifiques": "NNOs Spécifique"
};